import {Injectable} from '@angular/core';
import {FormActionHandlerService} from './base.service';
import {FormStatusService} from '../status.service';
import {SwalService} from '../../../fastlane-common/services/swal.service';
import {FormDataService} from '../data.service';
import {UserContextService} from '../../../user/services/user-context.service';
import {FormEmailService} from '../email.service';
import {FormShareService} from '../share.service';
import {formStatus, formStatuses, formTypes} from '../../form.constants';
import {ITEFormTypes, incentiveCategory} from '../../../project/project.constants';
import {SubmitFormActionHandlerService} from './submit.service';

@Injectable()
export class SignFormActionHandlerService extends FormActionHandlerService {
  constructor(
    private dataService: FormDataService,
    private emailService: FormEmailService,
    private shareService: FormShareService,
    private statusService: FormStatusService,
    private swal: SwalService,
    private userContext: UserContextService,
    private submitService: SubmitFormActionHandlerService
  ) {
    super();
  }

  exec(): Promise<any> {
    const that = this;
    const isUserGuest = this.userContext.isUserGuest();

    const isRd = incentiveCategory.rd.incentivePrograms.includes(
      this.shareService.currentIncentiveProgram
    );
    if (isRd && !this.shareService.form.isPaymentRequired) {
      return this.submitService.exec();
    }

    return new Promise((resolve, reject) => {
      const isNotStep = (
        !that.shareService.stepProject ||
          !that.shareService.stepProject.projectInfo ||
          !that.shareService.stepProject.projectInfo.incentiveProgram ||
          that.shareService.stepProject.projectInfo.incentiveProgram !== 'STEP'
      );
      if (!isNotStep) {
        that.statusService.changeStatus(formStatus.pendingSubmit);
      } else {
        that.statusService.changeStatus(formStatus.pendingPayment);
      }



      that.swal.load('Signing your form...', 'This will only take a second.');
      var date = new Date(Date.now());
      this.shareService.form.modifiedDate = date;
      that.dataService.saveForm().subscribe(
        successfulSave => {
          // If the user is a guest and he is not paying for this form, we need to email all project non-signees to pay up
          const payee =
            that.shareService.project.projectContacts[
              that.shareService.payingContactIndex
            ];

          if (
            isUserGuest &&
            !(
              payee &&
              payee.emailAddress.toLowerCase() ===
                that.userContext.currentUser.emailAddress
            ) &&
            isNotStep
          ) {
            // Send email to all signees
            that.swal.dismiss();
            that.swal.load(
              'Notifying contacts for payment...',
              'This will only take a second.'
            );

            that.emailService
              .sendPaymentRequiredEmailToAllNonSignees()
              .subscribe(
                successfulEmail => {
                  that.swal
                    .success({
                      title: 'Emails sent!',
                      text:
                        'Your project contacts have been notified to submit a payment for this form.'
                    })
                    .then(resolve)
                    .catch(resolve);
                },
                errorEmailing => {
                  that.swal.error({
                    title: 'Error requesting payment',
                    text: 'A valid payee was not found for this project!'
                  });
                  reject(
                    'An error occurred while sending emails to project contacts.'
                  );
                }
              );
          } else {
            const swalText =
              that.shareService.form.fees[0].amountDue > 0 && isNotStep
                ? 'Your form is now Pending Payment.'
                : 'Your form is now ready to be submitted for review by LED.';

            that.swal
              .success({
                title: 'Successfully submitted form signature!',
                text: swalText
              })
              .then(resolve)
              .catch(resolve);
          }
        },
        errorSaving => {
          if (errorSaving === 409) {
            reject(errorSaving);
          } else {
            reject(
              'An error occurred while signing your form. Please try again later.'
            );
          }
        }
      );
    });
  }
}
